module.exports = __webpack_public_path__ + "static/TownOfLight3-0fba604141005c72f6499daff654fd92.webp";